export const iconMap = {
  none: null,
  telephone: (
    <svg className="w-[3rem] h-[3rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_873_2160)">
        <path d="M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.08 14.82 15.69 14.9 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM21 6H18V3H16V6H13V8H16V11H18V8H21V6Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_873_2160">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ),
  pen: (
    <svg className="w-[3rem] h-[3rem]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path d="M22.5 2.56055L20.4805 4.58008L21.2998 5.40039C21.442 5.53578 21.5554 5.69845 21.6328 5.87891C21.7102 6.05938 21.75 6.25384 21.75 6.4502C21.75 6.64651 21.7102 6.84105 21.6328 7.02148C21.5554 7.20188 21.442 7.36466 21.2998 7.5L7.7998 21H3V16.2002L16.5 2.7002C16.6353 2.55801 16.7981 2.44457 16.9785 2.36719C17.159 2.28983 17.3535 2.25003 17.5498 2.25C17.7462 2.25 17.9406 2.28982 18.1211 2.36719C18.3016 2.44456 18.4642 2.55799 18.5996 2.7002L19.4199 3.51953L21.4395 1.5L22.5 2.56055ZM4.5 16.7998V19.5H7.2002L20.25 6.4502L17.5498 3.75L4.5 16.7998ZM13.5 4.06055L7.81055 9.75L6.75 8.68945L12.4395 3L13.5 4.06055Z" fill="#011410"/>
    </svg>
  ),
  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <path
        d="M22.5 18.75L21.4395 17.6895L19.5 19.629V13.5H18V19.629L16.0605 17.6895L15 18.75L18.75 22.5L22.5 18.75Z"
        fill="white"
      />
      <path
        d="M13.5 21H6V3.00001H12V7.50001C12.0011 7.89749 12.1596 8.27835 12.4406 8.55941C12.7217 8.84046 13.1025 8.99887 13.5 9.00001H18V11.25H19.5V7.50001C19.5027 7.40144 19.484 7.30346 19.4451 7.21282C19.4063 7.12218 19.3482 7.04105 19.275 6.97501L14.025 1.72501C13.959 1.65176 13.8778 1.59371 13.7872 1.55486C13.6966 1.51601 13.5986 1.4973 13.5 1.50001H6C5.60253 1.50116 5.22166 1.65957 4.94061 1.94062C4.65955 2.22168 4.50115 2.60254 4.5 3.00001V21C4.50115 21.3975 4.65955 21.7783 4.94061 22.0594C5.22166 22.3405 5.60253 22.4989 6 22.5H13.5V21ZM13.5 3.30001L17.7 7.50001H13.5V3.30001Z"
        fill="white"
      />
    </svg>
  ),
};
